"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 20 2" id=icon-remove><path d="M19 0H1a1 1 0 000 2h18a1 1 0 000-2z"></path></symbol>';
}